import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectDestructuringEmpty from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
import { useTranslation } from "@i18n";
import stl from "./ValidateInfoFromSema.module.css";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import useHelpers from "@hooks/useHelpers";
import VerifyOtp from "@/_MiniApps/auth/ui/OTP/VerifyOtp";
import { twMerge } from "tailwind-merge";
import useButtonLoading from "@hooks/useButtonLoading";
import { dispatchButtonLoading } from "@hooks/useButtonLoading";
import Loader from "@componentsShared/Loader/Loader";
import { checkTestFlag } from "@/common/config/websiteConfig";
var OTPForSema = function OTPForSema() {
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  var _useAribFinance$state = useAribFinance().state,
    userInfo = _useAribFinance$state.userInfo,
    orderData = _useAribFinance$state.orderData;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useAribFinance$remot = useAribFinance().remote_actions,
    fetch__VerifyAribOtp = _useAribFinance$remot.fetch__VerifyAribOtp,
    fetch__AribSendOtop = _useAribFinance$remot.fetch__AribSendOtop;
  var action__updateOrderInfo = useAribFinance().actions.action__updateOrderInfo;
  _objectDestructuringEmpty(useAribFinance().actions);
  var post_id = useAribFinance().queryParams.post_id;
  var buttonLoading = useButtonLoading();
  var _useState = useState(null),
    code = _useState[0],
    setCode = _useState[1];
  var length = 4;
  var _useState2 = useState(null),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState(true),
    initialLoad = _useState3[0],
    setInitialLoad = _useState3[1];
  var _useState4 = useState(false),
    disableResend = _useState4[0],
    setDisableResend = _useState4[1];
  var resendCountDownTime = checkTestFlag("TEST_OTP_RESEND_TIMER") ? 5 : 119;
  useEffect(function () {
    (code === null || code === void 0 ? void 0 : code.length) === length && RequestOTPFromSema();
  }, [code]);
  useEffect(function () {
    setTimeout(function () {
      setInitialLoad(false);
    }, 500);
  }, []);
  var RequestOTPFromSema = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var response, _response$data2, _response$data3, _response$data4, _response$data5, _response$data6, _response$data7, _response$data, _response$data8;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            dispatchButtonLoading(true);
            _context.n = 1;
            return fetch__VerifyAribOtp(code);
          case 1:
            response = _context.v;
            if (!response) {
              _context.n = 10;
              break;
            }
            dispatchButtonLoading(false);
            if (!((response === null || response === void 0 ? void 0 : response.code) === 230)) {
              _context.n = 2;
              break;
            }
            setError(response === null || response === void 0 ? void 0 : response.errors);
            return _context.a(2, null);
          case 2:
            if (!((response === null || response === void 0 ? void 0 : response.success) === false)) {
              _context.n = 3;
              break;
            }
            setError(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.message);
            return _context.a(2, null);
          case 3:
            if (!((response === null || response === void 0 ? void 0 : response.code) === 200 && (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.skipToUploadPage) == true)) {
              _context.n = 4;
              break;
            }
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 5
            }));
          case 4:
            if (!((response === null || response === void 0 ? void 0 : response.code) === 200 && (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.code) == 105)) {
              _context.n = 5;
              break;
            }
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 6
            }));
          case 5:
            if (!((response === null || response === void 0 ? void 0 : response.code) === 200 && (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.code) == 107)) {
              _context.n = 6;
              break;
            }
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 6
            }));
          case 6:
            if (!((response === null || response === void 0 ? void 0 : response.code) === 200 && (response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.code) == 106)) {
              _context.n = 7;
              break;
            }
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 7
            }));
          case 7:
            if (!((response === null || response === void 0 ? void 0 : response.code) === 200 && (response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.code) === "000")) {
              _context.n = 8;
              break;
            }
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 5,
              skipped: 1
            }));
          case 8:
            if (!(response.code === 200 && (response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.success) == false)) {
              _context.n = 9;
              break;
            }
            setError(response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.message);
            return _context.a(2, null);
          case 9:
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 9
            }));
          case 10:
            dispatchButtonLoading(false);
            // Handle error state
          case 11:
            return _context.a(2, null);
        }
      }, _callee);
    }));
    return function RequestOTPFromSema() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center max-w-[520px] md:p-10 flex-col items-start  mx-auto mt-[100px] md:mt-[72px] !w-[80%] max-w-[1152px] max-lg:!w-[90%] md:after:content-[''] md:after:bg-[#fafcff] md:after:fixed md:after:bottom-0 md:after:left-0 md:after:w-full md:after:h-full md:after:z-[-1] rmd:ounded-[16px] md:border md:border-[#EBF0F7] md:bg-white md:border-solid"
  }, /*#__PURE__*/React.createElement("i", {
    className: stl.otpIcon
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#3C56D4] text-center text-2xl font-bold leading-8 max-w-[313px]"
  }, t("enter_verification_code_proceed", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("p", {
    className: "mt-[16px] text-[#6C7A8D] text-center text-base font-medium leading-6"
  }, t("verification_code_otp_sent_id", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-6"
  }, /*#__PURE__*/React.createElement(VerifyOtp, {
    key: error ? "error-".concat(error) : "no-error",
    useForSema: true,
    value: code,
    phoneNumber: userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobile_number,
    loading: false,
    subClassName: "",
    title: "",
    label: "",
    className: "",
    btnText: "",
    otpBtn: "",
    length: length,
    error: error,
    isOtpSent: false,
    onChange: function onChange(value) {
      setCode(value);
      setError(null);
    },
    onValidate: function onValidate() {
      (function () {});
    },
    onEdit: function onEdit() {
      (function () {});
    },
    onResend: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var response, _response$data9, _response$data0, _response$data1;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return fetch__AribSendOtop();
          case 1:
            response = _context2.v;
            if (!response) {
              _context2.n = 4;
              break;
            }
            if (!((response === null || response === void 0 ? void 0 : response.code) == 0)) {
              _context2.n = 2;
              break;
            }
            if ((response === null || response === void 0 ? void 0 : response.status) == 429) {
              setDisableResend(true);
            }
            setError(response === null || response === void 0 ? void 0 : response.message);
            return _context2.a(2, null);
          case 2:
            if (!((response === null || response === void 0 ? void 0 : (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.skipToUploadPage) === true)) {
              _context2.n = 3;
              break;
            }
            return _context2.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 5
            }));
          case 3:
            action__updateOrderInfo({
              "transaction_id": response === null || response === void 0 ? void 0 : (_response$data0 = response.data) === null || _response$data0 === void 0 ? void 0 : _response$data0.transactionID
            });
            action__updateOrderInfo({
              "skipToUploadPage": response === null || response === void 0 ? void 0 : (_response$data1 = response.data) === null || _response$data1 === void 0 ? void 0 : _response$data1.skipToUploadPage
            });
          case 4:
            return _context2.a(2);
        }
      }, _callee2);
    })),
    setIsOtpSent: function setIsOtpSent() {},
    editNumberClass: ""
    // to change it back to 119
    ,
    countDownfromArib: Date.now() + resendCountDownTime * 1000,
    disabledResend: disableResend
  })), /*#__PURE__*/React.createElement("button", {
    onClick: RequestOTPFromSema,
    className: [twMerge("rounded border-none relative  text-white text-base font-bold leading-6 w-full h-12 mt-12 flex items-center justify-center", (code === null || code === void 0 ? void 0 : code.length) !== length ? "pointer-events-none bg-[#92a5c1] opacity-50 text-white" : "blueBtn"), buttonLoading ? "pointer-events-none opacity-50" : undefined].join(" ")
  }, t("verify_code", {
    ns: "web_checkout_finance"
  }), buttonLoading && /*#__PURE__*/React.createElement(Loader, {
    className: "!bg-transparent !absolute w-full h-full m-0 [zoom:0.6] [backdrop-filter:blur(4px)]"
  }))), initialLoad && /*#__PURE__*/React.createElement(Loader, null));
};
export default OTPForSema;